import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Trophy } from 'lucide-react';

const FloatingTrophy = () => {
  const location = useLocation();
  const [modalOpen, setModalOpen] = useState(false);
  const [navMenuOpen, setNavMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth < 640 : true
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setModalOpen(document.body.classList.contains('modal-open'));
      setNavMenuOpen(document.body.classList.contains('nav-menu-open'));
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    const onResize = () => setIsMobile(window.innerWidth < 640);
    window.addEventListener('resize', onResize, { passive: true });

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', onResize);
    };
  }, []);

  if (location.pathname.startsWith('/dashboard')) return null;
  if (location.pathname.startsWith('/contests')) return null;
  if (modalOpen || navMenuOpen) return null;

  // Chatbot button:
  //   mobile  → bottom: 1rem + safe-area,  right: 1rem,  size: 56px (w-14)
  //   desktop → bottom: 1.5rem,             right: 1.5rem, size: 64px (w-16)
  // Trophy sits directly above chatbot with 12px gap, same right edge.

  const bottom = isMobile
    ? 'calc(1rem + 56px + 12px + env(safe-area-inset-bottom, 0px))'
    : 'calc(1.5rem + 64px + 12px)';

  const right = isMobile ? '1rem' : '1.5rem';

  return (
    <Link
      to="/contests"
      className="fixed touch-manipulation shadow-lg
        w-14 h-14 sm:w-16 sm:h-16
        glass-card rounded-full
        flex items-center justify-center
        hover:bg-vortex-orange/20 active:bg-vortex-orange/30
        sm:hover:scale-110 active:scale-95 transition-all duration-300"
      title="View Contests"
      style={{ zIndex: 9998, bottom, right }}
    >
      <Trophy className="w-6 h-6 sm:w-7 sm:h-7 text-vortex-orange" />
    </Link>
  );
};

export default FloatingTrophy;
